import {
  Box,
  Button,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { Form, Controller, useFieldArray } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ImageWithDeleteButton from "../../Update_Campaign/comman/imageContainer";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { uploadImage } from "../../../redux/actions/addCampaigndata";
import {
  bodyAi,
  getBodyData,
  getHeaderData,
  headerAi,
  updateBodyAi,
} from "../../../redux/actions/ai_functions";
import {
  Add,
  Delete,
  ExpandLess,
  ExpandMore,
  StarRate,
} from "@mui/icons-material";
import InputFieldOrder from "./aiSaasInputFieldOrderBody";

const CreateAiBody = ({
  handleNext,
  validationBodySchema,
  activeStep,
  setActiveStep,
  manualStepChange,
  setManualStepChange,
}) => {
  const [updatingAgentId, setUpdatingAgentId] = useState();
  const [rechargeBillMobileCollapsed, setRechargeBillMobileCollapsed] =
    useState(true);
  const [rechargeBillDesktopCollapsed, setRechargeBillDesktopCollapsed] =
    useState(true);
  const [creditOfferCollapsed, setCreditOfferCollapsed] = useState(true);
  const [creditLoanOfferCollapsed, setCreditLoanOfferCollapsed] =
    useState(true);
  const [freeProductCollapsed, setFreeProductCollapsed] = useState(true);
  const [billPaymentCollapsed, setBillPaymentCollapsed] = useState(true);
  const [bodyContentMobileCollapsed, setBodyContentMobileCollapsed] =
    useState(true);
  const {
    headerDataForParticular,
    bodyDataForParticular,
    createAiBodyData,
    updatedAiBodyData,
    ongoing_ai_id,
  } = useSelector((state) => state?.aiDataReducer);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    register,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationBodySchema),
    defaultValues: {
      recharge_bill_payment_banner_mobile: bodyDataForParticular?.recharge_bill_payment_banner_mobile || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      recharge_bill_payment_banner_desktop: bodyDataForParticular?.recharge_bill_payment_banner_desktop || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      free_product_offer_banner_mobile: bodyDataForParticular?.free_product_offer_banner_mobile || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      bill_payment_issue_banner_mobile: bodyDataForParticular?.bill_payment_issue_banner_mobile || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      credit_card_offer_banner_mobile: bodyDataForParticular?.credit_card_offer_banner_mobile || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      credit_card_loan_offer_banner_mobile: bodyDataForParticular?.credit_card_loan_offer_banner_mobile || [
        {
          image: null,
          link: "",
          alt: "",
          target: "",
          order: null,
        },
      ],
      body_content_mobile: [{ logo: null, title: "", description: "" }],
      agent_id: "",
      created_by: "",
      bill_payment_service_logo: {
        image: null,
      },
      cash_voucher_heading: "",
      cash_voucher_subHeading: "",
      disclaimer: "",
      disclaimer_heading: "",
      recharge_bill_payment_heading: "",
    },
  });

  useEffect(() => {
    if (localStorage.getItem("updatingAgentId")) {
      setUpdatingAgentId(localStorage.getItem("updatingAgentId"));
    }
  }, []);

  const dispatch = useDispatch();

  const handleImage = async (logo, e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      setError(`${logo}.file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    clearErrors(`${logo}.file`);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await dispatch(uploadImage(formData));
      setValue(`${logo}.image`, res);
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogo = async (logo, e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      setError(`${logo}.file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    clearErrors(`${logo}.logo`);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await dispatch(uploadImage(formData));
      setValue(`${logo}.logo`, res);
    } catch (err) {
      console.error(err);
    }
  };

  console.log(errors,"errors");

  const {
    fields: rechargeBillPaymentMobile,
    append: rechargeBillPaymentMobileAppend,
    remove: rechargeBillPaymentMobileRemove,
  } = useFieldArray({
    control,
    name: "recharge_bill_payment_banner_mobile",
  });
  const {
    fields: rechargeBillPaymentDesktop,
    append: rechargeBillPaymentDesktopAppend,
    remove: rechargeBillPaymentDesktopRemove,
  } = useFieldArray({
    control,
    name: "recharge_bill_payment_banner_desktop",
  });
  const {
    fields: creditCardOffer,
    append: creditCardOfferAppend,
    remove: creditCardOfferRemove,
  } = useFieldArray({ control, name: "credit_card_offer_banner_mobile" });

  const {
    fields: creditCardLoanOffer,
    append: creditCardLoanOfferAppend,
    remove: creditCardLoanOfferRemove,
  } = useFieldArray({ control, name: "credit_card_loan_offer_banner_mobile" });

  const {
    fields: freeProductOffer,
    append: freeProductOfferAppend,
    remove: freeProductOfferRemove,
  } = useFieldArray({ control, name: "free_product_offer_banner_mobile" });

  const {
    fields: billPaymentIssue,
    append: billPaymentIssueAppend,
    remove: billPaymentIssueRemove,
  } = useFieldArray({ control, name: "bill_payment_issue_banner_mobile" });

  const onSubmit = (data) => {
    try {
      const {
        recharge_bill_payment_banner_mobile,
        recharge_bill_payment_banner_desktop,
        bill_payment_issue_banner_mobile,
        bill_payment_service_logo,
        free_product_offer_banner_mobile,
        credit_card_offer_banner_mobile,
        credit_card_loan_offer_banner_mobile,
        body_content_mobile,
        cash_voucher_heading,
        cash_voucher_subHeading,
        disclaimer,
        disclaimer_heading,
        recharge_bill_payment_heading,
        agent_id,
      } = data;
      const recreatedSchema = {
        recharge_bill_payment_banner_mobile,
        recharge_bill_payment_banner_desktop,
        bill_payment_issue_banner_mobile,
        free_product_offer_banner_mobile,
        credit_card_offer_banner_mobile,
        credit_card_loan_offer_banner_mobile,
        body_content_mobile,
        bill_payment_service_logo: bill_payment_service_logo.image,
        agent_id: agent_id,
        created_by: localStorage.getItem("userID"),
        cash_voucher_heading,
        cash_voucher_subHeading,
        disclaimer,
        disclaimer_heading,
        recharge_bill_payment_heading,
      };

      if (bodyDataForParticular?.created_by) {
        dispatch(updateBodyAi(recreatedSchema));
      } else {
        dispatch(bodyAi(recreatedSchema));
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (updatedAiBodyData && localStorage.getItem("isBodyUpdated")) {
      handleNext();
      localStorage.removeItem("isBodyUpdated");
    }
  }, [updatedAiBodyData]);

  useEffect(() => {
    if (createAiBodyData && localStorage.getItem("isBodyCreated")) {
      handleNext();
      localStorage.removeItem("isBodyCreated");
    }
  }, [createAiBodyData]);

  useEffect(() => {
    setValue("agent_id", headerDataForParticular?.agent_id || ongoing_ai_id);
    setValue(
      "recharge_bill_payment_heading",
      bodyDataForParticular?.recharge_bill_payment_heading || null
    );

    bodyDataForParticular?.recharge_bill_payment_banner_mobile?.forEach(
      (item, index) => {
        if (item) {
          setValue(
            `recharge_bill_payment_banner_mobile[${index}].image`,
            item.image
          );
          setValue(
            `recharge_bill_payment_banner_mobile[${index}].alt`,
            item.alt
          );
          setValue(
            `recharge_bill_payment_banner_mobile[${index}].link`,
            item.link
          );
          setValue(
            `recharge_bill_payment_banner_mobile[${index}].order`,
            item.order
          );
          setValue(
            `recharge_bill_payment_banner_mobile[${index}].target`,
            item.target
          );
        }
      }
    );

    bodyDataForParticular?.recharge_bill_payment_banner_desktop?.forEach(
      (item, index) => {
        if (item) {
          setValue(
            `recharge_bill_payment_banner_desktop[${index}].image`,
            item.image
          );
          setValue(
            `recharge_bill_payment_banner_desktop[${index}].alt`,
            item.alt
          );
          setValue(
            `recharge_bill_payment_banner_desktop[${index}].link`,
            item.link
          );
          setValue(
            `recharge_bill_payment_banner_desktop[${index}].order`,
            item.order
          );
          setValue(
            `recharge_bill_payment_banner_desktop[${index}].target`,
            item.target
          );
        }
      }
    );

    bodyDataForParticular?.bill_payment_issue_banner_mobile?.forEach(
      (item, index) => {
        if (item) {
          // Create an object to hold non-empty fields
          const fieldsToSet = {};

          if (item.image)
            fieldsToSet[`bill_payment_issue_banner_mobile[${index}].image`] =
              item.image;
          if (item.alt)
            fieldsToSet[`bill_payment_issue_banner_mobile[${index}].alt`] =
              item.alt;
          if (item.link)
            fieldsToSet[`bill_payment_issue_banner_mobile[${index}].link`] =
              item.link;
          if (item.order)
            fieldsToSet[`bill_payment_issue_banner_mobile[${index}].order`] =
              item.order;
          if (item.target)
            fieldsToSet[`bill_payment_issue_banner_mobile[${index}].target`] =
              item.target;

          // Set the values only for non-empty fields
          Object.entries(fieldsToSet).forEach(([key, value]) =>
            setValue(key, value)
          );
        }
      }
    );

    // Handle credit_card_offer_banner_mobile array
    bodyDataForParticular?.credit_card_offer_banner_mobile?.forEach(
      (item, index) => {
        if (item) {
          // Create an object to hold non-empty fields
          const fieldsToSet = {};

          if (item.image)
            fieldsToSet[`credit_card_offer_banner_mobile[${index}].image`] =
              item.image;
          if (item.alt)
            fieldsToSet[`credit_card_offer_banner_mobile[${index}].alt`] =
              item.alt;
          if (item.link)
            fieldsToSet[`credit_card_offer_banner_mobile[${index}].link`] =
              item.link;
          if (item.order)
            fieldsToSet[`credit_card_offer_banner_mobile[${index}].order`] =
              item.order;
          if (item.target)
            fieldsToSet[`credit_card_offer_banner_mobile[${index}].target`] =
              item.target;

          // Set the values only for non-empty fields
          Object.entries(fieldsToSet).forEach(([key, value]) =>
            setValue(key, value)
          );
        }
      }
    );

    bodyDataForParticular?.credit_card_loan_offer_banner_mobile?.forEach(
      (item, index) => {
        if (item) {
          // Create an object to hold non-empty fields
          const fieldsToSet = {};

          if (item.image)
            fieldsToSet[
              `credit_card_loan_offer_banner_mobile[${index}].image`
            ] = item.image;
          if (item.alt)
            fieldsToSet[`credit_card_loan_offer_banner_mobile[${index}].alt`] =
              item.alt;
          if (item.link)
            fieldsToSet[`credit_card_loan_offer_banner_mobile[${index}].link`] =
              item.link;
          if (item.order)
            fieldsToSet[
              `credit_card_loan_offer_banner_mobile[${index}].order`
            ] = item.order;
          if (item.target)
            fieldsToSet[
              `credit_card_loan_offer_banner_mobile[${index}].target`
            ] = item.target;

          // Set the values only for non-empty fields
          Object.entries(fieldsToSet).forEach(([key, value]) =>
            setValue(key, value)
          );
        }
      }
    );

    // Handle free_product_offer_banner_mobile array
    bodyDataForParticular?.free_product_offer_banner_mobile?.forEach(
      (item, index) => {
        if (item) {
          // Create an object to hold non-empty fields
          const fieldsToSet = {};

          if (item.image)
            fieldsToSet[`free_product_offer_banner_mobile[${index}].image`] =
              item.image;
          if (item.alt)
            fieldsToSet[`free_product_offer_banner_mobile[${index}].alt`] =
              item.alt;
          if (item.link)
            fieldsToSet[`free_product_offer_banner_mobile[${index}].link`] =
              item.link;
          if (item.order)
            fieldsToSet[`free_product_offer_banner_mobile[${index}].order`] =
              item.order;
          if (item.target)
            fieldsToSet[`free_product_offer_banner_mobile[${index}].target`] =
              item.target;

          // Set the values only for non-empty fields
          Object.entries(fieldsToSet).forEach(([key, value]) =>
            setValue(key, value)
          );
        }
      }
    );

    // Handle bill_payment_service_logo which is a single image
    setValue(
      "bill_payment_service_logo.image",
      bodyDataForParticular?.bill_payment_service_logo
    );
    setValue(
      "cash_voucher_heading",
      bodyDataForParticular?.cash_voucher_heading
    );
    setValue(
      "cash_voucher_subHeading",
      bodyDataForParticular?.cash_voucher_subHeading
    );
    setValue("disclaimer_heading", bodyDataForParticular?.disclaimer_heading);
    setValue("disclaimer", bodyDataForParticular?.disclaimer);
    const bodyContentMobile = bodyDataForParticular?.body_content_mobile?.[0];

    if (bodyContentMobile) {
      if (bodyContentMobile.logo) {
        setValue("body_content_mobile[0].logo", bodyContentMobile.logo);
      }
      if (bodyContentMobile.title) {
        setValue("body_content_mobile[0].title", bodyContentMobile.title);
      }
      if (bodyContentMobile.description) {
        setValue(
          "body_content_mobile[0].description",
          bodyContentMobile.description
        );
      }
    }
    setValue(
      "recarge_bill_payment_heading",
      bodyDataForParticular?.recharge_bill_payment_heading
    );
  }, [bodyDataForParticular, setValue]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container columnSpacing={0} sx={{ paddingY: "2rem", display:"flex", justifyContent:"space-around"}}>
          <Grid item xs={12} md={5} className="p-0">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                padding: "10px",
                border: rechargeBillMobileCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.recharge_bill_payment_banner_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (rechargeBillMobileCollapsed) {
                    setRechargeBillMobileCollapsed(false);
                  } else {
                    setRechargeBillMobileCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Recharge Bill Banner Mobile</span>
                {rechargeBillMobileCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>{" "}
              <div
                style={{
                  display: rechargeBillMobileCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <InputFieldOrder
                  fieldName={`recharge_bill_payment_banner_mobile`}
                  appendfunc={rechargeBillPaymentMobileAppend}
                  remove={rechargeBillPaymentMobileRemove}
                  fieldsArray={rechargeBillPaymentMobile}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                padding: "10px",
                border: rechargeBillDesktopCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.recharge_bill_payment_banner_desktop
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (rechargeBillDesktopCollapsed) {
                    setRechargeBillDesktopCollapsed(false);
                  } else {
                    setRechargeBillDesktopCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Recharge Bill Banner Desktop</span>
                {rechargeBillDesktopCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>{" "}
              <div
                style={{
                  display: rechargeBillDesktopCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <InputFieldOrder
                  fieldName={`recharge_bill_payment_banner_desktop`}
                  appendfunc={rechargeBillPaymentDesktopAppend}
                  remove={rechargeBillPaymentDesktopRemove}
                  fieldsArray={rechargeBillPaymentDesktop}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                padding: "10px",
                border: creditOfferCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.credit_card_offer_banner_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (creditOfferCollapsed) {
                    setCreditOfferCollapsed(false);
                  } else {
                    setCreditOfferCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Credit offer Banner</span>
                {creditOfferCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: creditOfferCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`credit_card_offer_banner_mobile`}
                  appendfunc={creditCardOfferAppend}
                  remove={creditCardOfferRemove}
                  fieldsArray={creditCardOffer}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                padding: "10px",
                border: creditLoanOfferCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.credit_card_loan_offer_banner_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (creditLoanOfferCollapsed) {
                    setCreditLoanOfferCollapsed(false);
                  } else {
                    setCreditLoanOfferCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Credit Loan offer Banner</span>
                {creditOfferCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: creditLoanOfferCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`credit_card_loan_offer_banner_mobile`}
                  appendfunc={creditCardLoanOfferAppend}
                  remove={creditCardLoanOfferRemove}
                  fieldsArray={creditCardLoanOffer}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                padding: "10px",
                border: freeProductCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.free_product_offer_banner_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (freeProductCollapsed) {
                    setFreeProductCollapsed(false);
                  } else {
                    setFreeProductCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Free Product Banner</span>
                {freeProductCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: freeProductCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`free_product_offer_banner_mobile`}
                  appendfunc={freeProductOfferAppend}
                  remove={freeProductOfferRemove}
                  fieldsArray={freeProductOffer}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
          <Divider className="m-3 bg-success" />
          </Grid>
          {/* <Divider orientation="vertical" className="bg-success" /> */}
          <Grid item xs={12} md={5}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
                padding: "10px",
                border: billPaymentCollapsed ? "" : "1px solid green",
                borderRadius: "10px",
              }}
            >
              <div
                className="w-100 text-center"
                style={{
                  border: errors?.bill_payment_issue_banner_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (billPaymentCollapsed) {
                    setBillPaymentCollapsed(false);
                  } else {
                    setBillPaymentCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Create Bill Payment Issue Banner</span>
                {billPaymentCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: billPaymentCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <InputFieldOrder
                  fieldName={`bill_payment_issue_banner_mobile`}
                  appendfunc={billPaymentIssueAppend}
                  remove={billPaymentIssueRemove}
                  fieldsArray={billPaymentIssue}
                  watch={watch}
                  register={register}
                  handleImageFunc={handleImage}
                  clearErrorsfunc={clearErrors}
                  handleUrlChangefunc={handleImage}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
                gap: "10px",
                border: bodyContentMobileCollapsed ? "" : "1px solid green",
                padding: "10px",
              }}
            >
              <div
                style={{
                  border: errors?.body_content_mobile
                    ? "2px solid red"
                    : "2px solid green",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "8px",
                  margin: "0px auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (bodyContentMobileCollapsed) {
                    setBodyContentMobileCollapsed(false);
                  } else {
                    setBodyContentMobileCollapsed(true);
                  }
                }}
              >
                <StarRate className="text-success" />
                <span>Body Content Mobile</span>
                {bodyContentMobileCollapsed ? (
                  <ExpandLess className="text-success" />
                ) : (
                  <ExpandMore className="text-success" />
                )}
              </div>
              <div
                style={{
                  display: bodyContentMobileCollapsed ? "none" : "flex",
                  flexDirection: "column",
                  width: "100%",

                  padding: "10px",
                }}
              >
                <div>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      variant="contained"
                      component="label"
                      color={
                        errors?.body_content_mobile &&
                        errors?.body_content_mobile[0]?.logo
                          ? "error"
                          : "success"
                      }
                      style={{ height: "fit-content" }}
                    >
                      Body content mobile logo
                      <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          handleLogo("body_content_mobile[0]", e);
                          clearErrors("body_content_mobile[0]?.logo");
                        }}
                      />
                    </Button>
                    <ImageWithDeleteButton
                      logoName="body_content_mobile[0].logo"
                      watch={watch}
                      setValue={setValue}
                    />
                  </Box>
                  {errors?.body_content_mobile && (
                    <span className="fs-6" style={{ color: "red" }}>
                      {errors?.body_content_mobile[0]?.logo?.message || ""}
                    </span>
                  )}
                </div>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Controller
                    name="body_content_mobile[0].title"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Title"
                        {...field}
                        error={
                          !!errors?.body_content_mobile &&
                          errors.body_content_mobile[0]?.title
                        }
                        helperText={
                          (errors?.body_content_mobile &&
                            errors?.body_content_mobile[0]?.title?.message) ||
                          ""
                        }
                        margin="normal"
                        className="w-100"
                      />
                    )}
                  />
                  <Controller
                    name="body_content_mobile[0].description"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Description"
                        {...field}
                        error={
                          !!errors?.body_content_mobile &&
                          errors?.body_content_mobile[0]?.description
                        }
                        helperText={
                          (errors?.body_content_mobile &&
                            errors?.body_content_mobile[0]?.description
                              ?.message) ||
                          ""
                        }
                        margin="normal"
                        className="w-100"
                      />
                    )}
                  />
                </Box>
              </div>
            </div>
            <Divider className="m-3 bg-success" />
            <div style={{ margin: "10px 0px", padding:"0px 10px" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  component="label"
                  color={
                    errors.bill_payment_service_logo?.image
                      ? "error"
                      : "success"
                  }
                  style={{ height: "fit-content" }}
                >
                  Bill payment service logo
                  <input
                    type="file"
                    hidden
                    onChange={(e) => {
                      handleImage("bill_payment_service_logo", e);
                      clearErrors("bill_payment_service_logo.image");
                    }}
                  />
                </Button>
                <ImageWithDeleteButton
                  logoName="bill_payment_service_logo.image"
                  watch={watch}
                  setValue={setValue}
                />
              </Box>
              {errors?.bill_payment_service_logo && (
                <span style={{ fontSize: "200", color: "red" }}>
                  {errors?.bill_payment_service_logo?.image?.message}
                </span>
              )}
            </div>
            <Divider className="m-3 bg-success" />
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px", padding:"10px" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="cash_voucher_heading"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Voucher Heading"
                      {...field}
                      error={!!errors.cash_voucher_heading}
                      helperText={errors?.cash_voucher_heading?.message || ""}
                    />
                  )}
                />
                <Controller
                  name="cash_voucher_subHeading"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Voucher subHeading"
                      {...field}
                      error={!!errors.cash_voucher_subHeading}
                      helperText={
                        errors?.cash_voucher_subHeading?.message || ""
                      }
                    />
                  )}
                />
              </Box>
              <Divider className=" my-3 bg-success" />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="disclaimer_heading"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="disclaimer Heading"
                      {...field}
                      error={!!errors.disclaimer_heading}
                      helperText={errors?.disclaimer_heading?.message || ""}
                    />
                  )}
                />
                <Controller
                  name="disclaimer"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="disclaimer"
                      {...field}
                      error={!!errors.disclaimer}
                      helperText={errors?.disclaimer?.message || ""}
                    />
                  )}
                />
              </Box>
              <Divider className="m-3 bg-success" />
              <Box>
                <Controller
                  name="recharge_bill_payment_heading"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Recharge Bill Payment Heading"
                      {...field}
                      error={!!errors.recharge_bill_payment_heading}
                      helperText={
                        errors?.recharge_bill_payment_heading?.message || ""
                      }
                    />
                  )}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                <Controller
                  name="agent_id"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Agent ID"
                      {...field}
                      error={!!errors.agent_id}
                      helperText={errors.agent_id?.message || ""}
                      margin="normal"
                      className="w-fit"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  )}
                />
              </Box>
            </div>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingX: "1rem",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              if (activeStep >= 1) {
                setManualStepChange(true);
                if (ongoing_ai_id) {
                  dispatch(
                    getHeaderData({ agent_id: ongoing_ai_id, name: "header" })
                  );
                } else {
                  dispatch(
                    getHeaderData({ agent_id: updatingAgentId, name: "header" })
                  );
                }
                setActiveStep((prev) => prev - 1);
              }
            }}
          >
            Previous
          </Button>
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </Box>
      </form>
    </>
  );
};

export default CreateAiBody;
